























import { MemberProfile } from '@/types/response';
import { CommonUtils } from '@/util/commonUtils';
import { Component , Vue } from 'vue-property-decorator';
import { ObjectFactory } from '../config/objectFactory';
@Component({
    data() {
        return {
            memberProfile: '',
            initialLatters: '',
        };
    },
})
export default class TopNavigationBar extends Vue {
    private fullname: string = '';
    private memberProfile: MemberProfile | undefined;
    public mounted() {
        this.memberProfile = ObjectFactory.getCacheService().getMemberInfo();
        this.$data.memberProfile = this.memberProfile;
        setTimeout(() => {
            this.fullname = ObjectFactory.getCacheService().getSessionInfo().fullname;
            const arr = this.fullname.split(' ');
            let initialLetters = '';
            if (arr.length > 1) {
                initialLetters = arr[0].charAt(0) + arr[1].charAt(0);
            } else if (arr.length === 1) {
                initialLetters = arr[0].charAt(0) + arr[0].charAt(1);
            }
            this.$data.initialLatters = initialLetters.toUpperCase();
        });
    }

    private logout() {
        CommonUtils.logout(this.$store.state);
    }
}
